import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["step"]

  connect() {
    this.animateIn()
  }

  animateIn() {
    if (this.hasStepTarget) {
      this.stepTarget.classList.add("animate-fade-in")
    }
  }
}
